import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { MaterialModule } from "../material/material.module";
import { SharedModule } from "../shared/shared.module";
import { PadlockTokenEffects } from "./state/padlock-token.effects";
import {
  padlockReducer,
  padlockTokenFeatureKey,
} from "./state/padlock-token.reducer";
import { HeroIconModule } from "../icons/heroIcon.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    HeroIconModule,
    StoreModule.forFeature(padlockTokenFeatureKey, padlockReducer),
    EffectsModule.forFeature([PadlockTokenEffects]),
  ],
})
export class PadlockModule {}
